import Markdown from 'react-markdown';
import { cn } from '~/lib/utils';

interface MarkdownViewerProps {
    children: string;
    className?: string;
}

function cleanMarkdownText(text: string): string {
    if (!text || typeof text !== 'string') return text;
    
    return text
        // Remove excessive line breaks (more than 2 consecutive newlines)
        .replace(/\n{3,}/g, '\n\n')
        // Remove trailing spaces before line breaks
        .replace(/ +\n/g, '\n')
        // Remove leading spaces after line breaks (but preserve code indentation)
        .replace(/\n +/g, (match) => {
            // If it's likely code indentation (4+ spaces or tabs), preserve it
            const spaces = match.substring(1);
            if (spaces.length >= 4 || spaces.includes('\t')) {
                return match;
            }
            // Otherwise remove the spaces
            return '\n';
        })
        // Clean up multiple spaces (but not in code blocks)
        .replace(/ {2,}/g, ' ')
        // Remove empty lines that are just spaces
        .replace(/\n +\n/g, '\n\n')
        .trim();
}

export default function MarkdownViewer({ children, className }: MarkdownViewerProps) {
    return (
        <Markdown className={cn('flex flex-col prose prose-sm prose-slate max-w-none', className)}>
            {cleanMarkdownText(children)}
        </Markdown>
    );
}